import { bizGet, bizPatch, bizPost } from '@/shared/api/bizClient';

import type { ConsentPreference, ReminderCandidate, ReminderChannel } from './types';

interface ListEnvelope<T> {
  items: T[];
}

export async function enqueueReminders(branchId: string): Promise<ReminderCandidate[]> {
  const response = await bizPost<ListEnvelope<ReminderCandidate>>(
    '/biz/reminders/enqueue',
    undefined,
    { params: { branchId } },
  );
  return response.items;
}

export async function listConsentPreferences(
  customerId: string,
): Promise<ConsentPreference[]> {
  const response = await bizGet<ListEnvelope<ConsentPreference>>(
    `/biz/customers/${customerId}/consents`,
  );
  return response.items;
}

export async function setConsentPreference(
  customerId: string,
  channel: ReminderChannel,
  optIn: boolean,
): Promise<ConsentPreference> {
  return bizPatch<ConsentPreference, { channel: ReminderChannel; optIn: boolean }>(
    `/biz/customers/${customerId}/consents`,
    { channel, optIn },
  );
}
